// useInternalCompany.js
import { computed} from 'vue';
import { useCurrentUserStore } from '../pinia/CurrentUserStore';
import { InternalCompany } from '@/types/Companies/InternalCompany';
import { CurrentUserStore } from '@/types/pinia/CurrentUserStore';
import { phpToMoment } from './General';
import { useStore } from 'vuex';

export function useInternalCompany(){
    const currentUser = useCurrentUserStore() as CurrentUserStore;
    const internal_company = computed<InternalCompany>(() => currentUser.company_data);
    const id = computed(() => currentUser.company_data?.id )
    const companyLocale = computed( () => currentUser.company_data?.settings?.defaults?.number_local ?? currentUser.company_data?.settings?.defaults?.language ?? "ar");
    return {internal_company, id, companyLocale}
}


export function useInternalBillingAddress(){
    const currentUser = useCurrentUserStore() as CurrentUserStore;
    const billingAddresse = computed(() => currentUser.company_data?.billing);
    const id = computed(() => currentUser.company_data?.billing.id );
    const country_id = computed(() => currentUser.company_data?.billing?.country_id );
    return {billingAddresse, id, country_id}
}

export function internalVat(){
        const currentUser = useCurrentUserStore() as CurrentUserStore;
    const internal_vat = computed(() => currentUser.company_data?.settings?.vat ?? "");
    return internal_vat;
}

export function momentDateFormat(){
    const currentUser = useCurrentUserStore();
    return computed(() => phpToMoment(currentUser.company_data.settings?.date_format ?? "Y-m-d"));
}


export function useInternalUnit(){
    const { internal_company }= useInternalCompany();
    const store = useStore();
    return computed(() => {
        return store.getters["units/getUnitById"](internal_company.value.settings?.defaults?.internal_unit);
    });
}
export function useSalesUnit(){
    const { internal_company }= useInternalCompany();
    const store = useStore();
    return computed(() => {
        if(!internal_company.value?.settings?.defaults?.sales_unit){
            return store.getters["units/getUnitById"](internal_company.value?.settings?.defaults?.internal_unit);
        }else{
            return store.getters["units/getUnitById"](internal_company.value.settings?.defaults?.sales_unit);
        }
    });
}

